import React from "react";
import { Header, Segment, Button } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { SafeMoment } from "../../../../components/SafeMoment";
import Modal from "../../../../components/global_components/AccessibleModal";
import "./RenewalPromptModal.scss";
import identitySelectors from "../../../../selectors/identity";

export const RenewalPromptModal = (props: any) => {
  const { renewalPermits, name, site, id, userId, onClose, open } = props;
  const history = useHistory();
  const beginNewApplication = () => {
    if (userId) {
      onClose();
    } else {
      history.push(`/${site}/public/permits/apply?permitsTypeId=${id}`);
    }
  };

  const isPermitUser = identitySelectors.isPermitsUser();
  const isPermitAdmin = identitySelectors.isPermitsAdmin();
  const isSuperAdmin = identitySelectors.isSuperAdmin();
  const beginRenewal = (parentId: any) => {
    const staffSubmission = isPermitUser || isPermitAdmin || isSuperAdmin;
    if (userId) {
      window.location.href = `/${site}/public/permits/apply?permitsTypeId=${id}&userId=${userId}&parentId=${parentId}&staffSubmission=${staffSubmission}`;
    } else {
      window.location.href = `/${site}/public/permits/apply?permitsTypeId=${id}&parentId=${parentId}&staffSubmission=${staffSubmission}`;
    }
  };

  return (
    <>
      <Modal isOpen={open} onClose={() => onClose()} aria-labelledby='renewal-prompt-modal-header'>
        <Segment padded textAlign='left' size='large' style={{ minWidth: "40vw" }}>
          <Header id='renewal-prompt-modal-header' as='h3'>
            Before Applying... Are You Trying to Renew This Record?
          </Header>
          {renewalPermits &&
            renewalPermits.map((permit: any) => {
              return (
                <Segment key={permit.id} className='past-renewal PermitSelect' onClick={() => beginRenewal(permit.id)}>
                  <div className='renewal-name'>
                    <Button primary content='Renew' size='small' />
                    <div>
                      <Header as='h4'>
                        <Header.Subheader>{name}</Header.Subheader>
                        {permit.attributes.reservation_number}
                      </Header>
                    </div>
                  </div>
                  <div className='renewal-data'>
                    <p>{permit.attributes.primary_identifier}</p>
                    <p>
                      {Date.parse(permit.attributes.expired_at) < Date.now() ? "Expired " : "Expires "}
                      <SafeMoment format='MMM D, YYYY'>{permit.attributes.expired_at}</SafeMoment>
                    </p>
                  </div>
                </Segment>
              );
            })}
          <Header as='h4' className='tw-mt-8'>
            {" "}
            {"If It's Not a Renewal, You Can Apply Below."}{" "}
          </Header>
          <Button secondary content='Begin New Application' onClick={beginNewApplication} size='small' />
        </Segment>
      </Modal>
    </>
  );
};
